import TimerBoxSimulator from './TimerBoxSimulatorContainer'

export default TimerBoxSimulator
